import React, { useEffect } from "react";
import { MusicHallFormStyled } from "./styled";
import { Controller } from "react-hook-form";
import {
  FILTER_EVENT_END_TIME,
  FILTER_EVENT_START_TIME,
  FILTER_SETUP_END_TIME,
  IS_IN_OPTIONS,
  MUSIC_HALL_TIME_OPTIONS,
} from "utils/functions/roomBookingTime";
import { Inputs } from "components";

// กฎเวลาเหมือนฝั่งลูกค้า: เริ่มเตรียมงาน < เริ่มงาน < จบงาน <= จบเก็บงาน / ห้ามวันย้อนหลัง
const MusicHallForm = ({
  control,
  errors,
  equipmentAdditionalList,
  equipmentProviderList,
  musicHallRoomList,
  setupStartTime,
  setupEndTime,
  eventStartTime,
  eventEndTime,
  setValue,
}) => {
  const setupEndOptions = FILTER_SETUP_END_TIME(setupStartTime);
  const eventStartOptions = FILTER_EVENT_START_TIME(
    setupStartTime,
    setupEndTime,
  );
  const eventEndOptions = FILTER_EVENT_END_TIME(eventStartTime, setupEndTime);

  // เปลี่ยนเวลาตัวใดตัวหนึ่งแล้วค่าที่เลือกไว้หลุดช่วง ล้างให้เลือกใหม่ (ไล่ตามลำดับ เตรียม -> งาน)
  // ค่าใน portal เป็น string (เดิมเทียบ .value จึงไม่เคยล้างจริง)
  useEffect(() => {
    if (!IS_IN_OPTIONS(setupEndTime, setupEndOptions)) {
      setValue("setup_cleanup_end_time", "");
    }
    if (!IS_IN_OPTIONS(eventStartTime, eventStartOptions)) {
      setValue("event_start_time", "");
      setValue("event_end_time", "");
    } else if (!IS_IN_OPTIONS(eventEndTime, eventEndOptions)) {
      setValue("event_end_time", "");
    }
  }, [setupStartTime, setupEndTime, eventStartTime, eventEndTime]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MusicHallFormStyled>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              {...field}
              label={"ชื่อ"}
              // placeholder={t('test')}
              errors={errors.booker_first_name?.message}
            />
          )}
          name="booker_first_name"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              {...field}
              label={"นามสกุล"}
              // placeholder={t('test')}
              errors={errors.booker_last_name?.message}
            />
          )}
          name="booker_last_name"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              {...field}
              label={"เบอร์โทรศัพท์"}
              // placeholder={t('test')}
              errors={errors.booker_phone?.message}
            />
          )}
          name="booker_phone"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              {...field}
              label={"อีเมล"}
              // placeholder={t('test')}
              errors={errors.booker_email?.message}
            />
          )}
          name="booker_email"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.Dropdown
              {...field}
              label={"Music Hall Room"}
              options={musicHallRoomList}
              // placeholder={t('test')}
              errors={errors.room_ref_id?.message}
            />
          )}
          name="room_ref_id"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.DateTime
              {...field}
              minDate={new Date()}
              label={"เลือกวัน"}
              // placeholder={t('test')}
              errors={errors.booking_date?.message}
            />
          )}
          name="booking_date"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.Dropdown
              {...field}
              label={"เวลาเริ่มต้นเตรียมงานเก็บงาน"}
              // placeholder={t('test')}
              options={MUSIC_HALL_TIME_OPTIONS}
              errors={errors.setup_cleanup_start_time?.message}
            />
          )}
          name="setup_cleanup_start_time"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.Dropdown
              {...field}
              label={"เวลาสิ้นสุดเตรียมงานเก็บงาน"}
              options={setupEndOptions}
              // placeholder={t('test')}
              errors={errors.setup_cleanup_end_time?.message}
            />
          )}
          name="setup_cleanup_end_time"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.Dropdown
              {...field}
              label={"เวลาเริ่มต้นของงาน"}
              // placeholder={t('test')}
              options={eventStartOptions}
              errors={errors.event_start_time?.message}
            />
          )}
          name="event_start_time"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.Dropdown
              {...field}
              label={"เวลาสิ้นสุดของงาน"}
              options={eventEndOptions}
              // placeholder={t('test')}
              errors={errors.event_end_time?.message}
            />
          )}
          name="event_end_time"
          defaultValue=""
        />
      </div>

      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              {...field}
              label={"ชื่อกิจกรรม"}
              // placeholder={t('test')}
              errors={errors.event_name?.message}
            />
          )}
          name="event_name"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.Dropdown
              {...field}
              label={"ประเภทของกิจกรรม"}
              options={[
                { label: "Concert", value: "1" },
                { label: "Competition", value: "2" },
                { label: "Recording", value: "3" },
                { label: "Racital", value: "4" },
                { label: "Rehearsal", value: "5" },
                { label: "Master Class / Workshop", value: "6" },
                { label: "Exhibitiont", value: "7" },
                { label: "Seminar / Forum", value: "8" },
              ]}
              // placeholder={t('test')}
              errors={errors.event_type?.message}
            />
          )}
          name="event_type"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              {...field}
              type="number"
              min="1"
              label={"จำนวนผู้เข้าร่วม"}
              // placeholder={t('test')}
              errors={errors.expected_attendees?.message}
            />
          )}
          name="expected_attendees"
          defaultValue=""
        />
      </div>

      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.InputMultiSelect
              {...field}
              isMulti
              label={"อุปกรณ์ที่จัดให้ (ไม่คิดค่าใช้จ่าย)"}
              options={equipmentProviderList}
              // placeholder={t('test')}
              errors={errors.additional_equipment_provider?.message}
            />
          )}
          name="additional_equipment_provider"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.InputMultiSelect
              {...field}
              isMulti
              label={"อุปกรณ์เพิ่มเติม (คิดค่าใช้จ่าย)"}
              options={equipmentAdditionalList}
              // placeholder={t('test')}
              errors={errors.additional_equipment_additional?.message}
            />
          )}
          name="additional_equipment_additional"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextArea
              {...field}
              label={"Special Request"}
              // placeholder={t('test')}
              errors={errors.special_request?.message}
            />
          )}
          name="special_request"
          defaultValue=""
        />
      </div>
    </MusicHallFormStyled>
  );
};

MusicHallForm.propTypes = {};

export default MusicHallForm;
